import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, Form } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import logoLight from "../../assets/images/logo-light.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import {
  emailRegex,
  InputPlaceHolder,
  validationMessages,
} from "Components/constants/validation";
import { verifyEmail } from "Api/UserApi";
import { toast } from "react-toastify";
import BaseInput from "Components/Base/BaseInput";
import BaseButton from "Components/Base/BaseButton";
import ForgetPasswordFooter from "Components/Common/ForgetPasswordFooter";
import { loginLabels } from "Components/constants/Common";
import { HttpStatusCodes } from "helpers/Enums/Enums";
import { setItem } from "Components/constants/SessionStores";

const VerifyEmailPage = (props: any) => {
  document.title = loginLabels.verifyEmail;

  const navigate = useNavigate();

  const [loader, setLoader] = useState<boolean>(false);

  useEffect(() => {
    sessionStorage.removeItem(loginLabels.email);
  }, []);

  const validation: any = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required(validationMessages.required(loginLabels.Email))
        .matches(emailRegex, validationMessages.format(loginLabels.Email)),
    }),
    onSubmit: async (values) => {
      setLoader(true);
      const payload = {
        email: values.email,
      };

      await verifyEmail(payload)
        .then((res) => {
          if (
            res?.statusCode &&
            HttpStatusCodes.SUCCESS.includes(res?.statusCode)
          ) {
            toast.success(res?.message);
            setItem(loginLabels.email, values.email);
            navigate("/forget-password");
          } else {
            toast.error(res?.message);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || error?.message);
          setLoader(false);
        })
        .finally(() => setLoader(false));
    },
  });

  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={logoLight} alt="" height="20" />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-success">
                      {loginLabels.forgotPassword}?
                    </h5>

                    <i className="ri-mail-send-line display-5 text-success mb-3"></i>
                  </div>

                  <Alert
                    className="border-0 alert-warning text-center mb-2 mx-2"
                    role="alert"
                  >
                    {loginLabels.verifyEmailMessage}
                  </Alert>
                  <div className="p-2">
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <BaseInput
                          name={loginLabels.email}
                          label={loginLabels.Email}
                          className="form-control"
                          placeholder={InputPlaceHolder(loginLabels.Email)}
                          type="text"
                          onChange={validation.handleChange}
                          handleBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          touched={validation.touched.email}
                          error={validation.errors.email}
                          required
                        />
                      </div>

                      <div className="text-center mt-4">
                        <BaseButton
                          color="success"
                          type="submit"
                          label={loginLabels.sendOtp}
                          loader={loader}
                          className="w-100"
                        />
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <ForgetPasswordFooter
                message={loginLabels.loginNavigateMessage}
                linkText={loginLabels.clickHere}
                linkUrl={"/login"}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

VerifyEmailPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(VerifyEmailPage);
